import { memo, Fragment } from "react";
import { Marker } from "react-leaflet";
import { ExpandedCluster } from "./ExpandedCluster";
import { CrimeMarker } from "./CrimeMarker";
import { getColorByDensity } from "./utils/getColorByDensity";
import L from 'leaflet';

// Highly Optimized Group Rendering Component
// Memoization prevents re-rendering all groups when a single cluster is expanded/closed
export const MapGroup = memo(({ group, isExpanded, onExpand, onClose, maxDensity, totalSpots, onSelect, config }) => {
    const hasMultiple = group.spots.length > 1;

    if (hasMultiple && !isExpanded) {
        // Render native cluster marker with number and "pop" animation
        const clusterColor = getColorByDensity(group.density, maxDensity, totalSpots);
        const clusterHtml = `<div style="
            background-color: ${clusterColor}; 
            color: white; 
            border-radius: 50%; 
            width: 12px; 
            height: 12px; 
            display: flex; 
            align-items: center; 
            justify-content: center; 
            font-weight: bold; 
            font-family: sans-serif; 
            font-size: 0.6rem;
            animation: pulseCluster 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
        ">${group.spots.length}</div>`;
        
        const clusterIcon = L.divIcon({
            html: clusterHtml,
            className: "",
            iconSize: [12, 12],
            iconAnchor: [10, 10]
        });

        return (
            <Fragment>
                {/* CSS Injetado para as animações rodarem nos ícones divIcon */}
                <style>{`
                    @keyframes pulseCluster {
                        0% { transform: scale(0); opacity: 0; }
                        100% { transform: scale(1); opacity: 1; }
                    }
                    @keyframes spinIn {
                        0% { transform: scale(0) rotate(-180deg); opacity: 0; }
                        100% { transform: scale(1) rotate(0deg); opacity: 1; }
                    }
                `}</style>

                <Marker 
                    position={[group.latitude, group.longitude]}
                    icon={clusterIcon}
                    eventHandlers={{ click: () => onExpand(group.id) }}
                />
            </Fragment>
        );
    } else if (hasMultiple && isExpanded) {
        // Usa o componente animado para espalhar (spiderfy) os marcadores
        return (
            <ExpandedCluster 
                group={group}
                maxDensity={maxDensity}
                totalSpots={totalSpots}
                onSelect={onSelect}
                config={config}
                onClose={onClose}
                CrimeMarker={CrimeMarker} // Passando o componente como prop para renderizar internamente
            />
        );
    } else {
        // Single non-overlapping spot
        return (
            <CrimeMarker
                spot={group.spots[0]}
                density={group.density}
                maxDensity={maxDensity}
                totalSpots={totalSpots}
                onSelect={onSelect}
                config={config}
            />
        );
    }
});

MapGroup.displayName = "MapGroup";